// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import Snackbar from 'components/@extended/Snackbar';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getBrowserDateFnsLocale } from 'utils/dateFnsLocale';
import { CityBillsUploadProvider } from './components/city-bills-uploader';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getBrowserDateFnsLocale()}>
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <AuthProvider>
            <CityBillsUploadProvider apiBaseUrl="" maxFiles={10}>
              <>
                <Routes />
                <Snackbar />
              </>
            </CityBillsUploadProvider>
          </AuthProvider>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  </LocalizationProvider>
);

export default App;
